
import {Icon} from "react-icons-kit";
import {instagram} from 'react-icons-kit/icomoon/instagram'
const Instagram = () => {
    return (
        <div>
            <Icon icon={instagram} size={20} />
        </div>
    );
};

export default Instagram;